/**
 * Created by Ning Jiang on 2019-01-09.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameAssets} from "../../ThorGameAssets";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import {ThorInitialWinCountUp} from "../../winpresentation/initial/ThorInitialWinCountUp";
import {ThorFreeSpinOutroController} from "./ThorFreeSpinOutroController";

export class ThorFreeSpinOutroView extends ScreenView {

    private _container:PIXI.Container;
    private _banner:PIXI.Sprite;
    private _youWonText:PIXI.Text;
    private _numberOfSpinsText:PIXI.BitmapText;
    private _spinsPlayed:PIXI.Text;
    private _numberOfSpins:number = 0;

    private _winAmount:number = 0;
    private _blackGfx:PIXI.Graphics;
    private _winCountUpYellow:ThorInitialWinCountUp;
    private _darkenBackground:PIXI.Graphics;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
        this._winCountUpYellow = new ThorInitialWinCountUp(ThorGameConfig.TEXT_STYLES.COUNTUP_YELLOW_BITMAP_STYLE);

    }

    protected initAnimations():void {
        super.initAnimations();
        this._blackGfx = new PIXI.Graphics();
        this._blackGfx.alpha = 0;
        this.addChild(this._blackGfx);
    }

    public updateText(spinsPlayed:number, totalWin:number):void {
        this._numberOfSpins = spinsPlayed;
        this._winAmount = totalWin;
        this._numberOfSpinsText.text = "" + this._numberOfSpins;


    }

    protected createGameGraphics():PIXI.DisplayObject {
        const cont:PIXI.Container = new PIXI.Container();

        this._darkenBackground = new PIXI.Graphics();
        this._darkenBackground.alpha = 0.5;

        this._banner = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.FREE_SPIN_INTRO_OUTRO_BANNER)[0]);
        this._banner.anchor.set(0.5, 0.53);

        this._youWonText = new PIXI.Text(Translation.translate("YOU WON"), ThorGameConfig.TEXT_STYLES.FREESPIN_OUTRO_YOU_WON);

        this._numberOfSpinsText = new PIXI.BitmapText("" + this._numberOfSpins, {
            fontName: ThorGameConfig.TEXT_STYLES.FREESPIN_OUTRO_NUMBER.font.name!,
            fontSize: ThorGameConfig.TEXT_STYLES.FREESPIN_OUTRO_NUMBER.font.size
        });
        this._spinsPlayed = new PIXI.Text(Translation.translate("SPINS PLAYED"), ThorGameConfig.TEXT_STYLES.FREESPIN_OUTRO_SPINS_PLAYED);

        this._youWonText.anchor.set(0.5, 0.5);
        this._spinsPlayed.anchor.set(0.5, 0.5);
        this._numberOfSpinsText.anchor = new PIXI.Point(0.5, 0.5);


        this._youWonText.position.set(0, -240);
        this._winCountUpYellow.position.set(0, -90);
        this._spinsPlayed.position.set(0, 60);
        this._numberOfSpinsText.position.set(0, 120);

        cont.addChild(this._darkenBackground);
        cont.addChild(this._banner);
        cont.addChild(this._youWonText);
        cont.addChild(this._winCountUpYellow);
        cont.addChild(this._numberOfSpinsText);
        cont.addChild(this._spinsPlayed);

        this._container = cont;
        return this._container;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._container.scale.set(this._orientationScale, this._orientationScale);

        this._blackGfx.clear();
        this._blackGfx.beginFill(0x000000);
        this._blackGfx.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._blackGfx.endFill();

        this._darkenBackground.clear();
        this._darkenBackground.beginFill(0x000000);
        this._darkenBackground.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._darkenBackground.endFill();
        this._darkenBackground.position.set(-this._darkenBackground.width * 0.5, -this._darkenBackground.height * 0.5);

    }

    protected startPresentation(data:ThorParsedGameData, onShowComplete?:() => void):void {
        this.alpha = 0;
        this._blackGfx.alpha = 0;
        this._container.alpha = 1;
        this._button.alpha = 1;
        if(this._autoCloseTimer) {
            this._autoCloseTimer.alpha = 1;
        }
        const spinsPlayed = data.numberOfFreespinsPlayed ? data.numberOfFreespinsPlayed : 0;
        this.updateText(spinsPlayed, data.totalWin);

        ThorGameModuleConfig.thorRandomWildIconView.disableRandomWildIconTL(0);
        ThorGameModuleConfig.thorReelWildIconView.disableReelWildIconTL(0);
        ThorGameModuleConfig.thorMultiplierIconView.disableMultiplierIconTL(0);

        const tl:TimelineLite = new TimelineLite(),
            // #311
            totalWinBelowStake: boolean = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalWin <= data.playedBetValue)),
            duration: number = (totalWinBelowStake ? 0 : 1);

        // #311
        if (!totalWinBelowStake) {
            tl.add(() => this.playSound());
        }
        tl.add(new TweenLite(this, 1, {alpha : 1, ease : Linear.easeNone}));

        tl.add(() => this._winCountUpYellow.currentWinRatio = WinRatioType.LARGE);
        // #311
        tl.add(this._winCountUpYellow.getCountUpAnimation(0, data.totalWin, duration, 1, true, !totalWinBelowStake), 0.5);
        tl.add(()=>{
            this._winCountUpYellow.currentValue(data.totalWin);
        })
        tl.add(() => this.switchMusic());

        if(onShowComplete) {
            tl.add(() => {onShowComplete()});
        }
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this.fadeInBlack());

        timeline.add(() => {
            this._container.alpha = 0;
            this._button.alpha = 0;
            if(this._autoCloseTimer) {
                this._autoCloseTimer.alpha = 0;
            }
        });

        timeline.add(() => ThorFreeSpinOutroController.actuallyDoTransition());
        timeline.add(new TweenLite(this, 1, {alpha : 0, ease : Linear.easeNone}));
        timeline.add(() => super.stopPresentation(closeCallback));

    }

    private fadeInBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 1, {alpha : 1, ease : Linear.easeNone}));
        return tl;

    }

    private playSound() {
        SlotGame.sound.playEffect(ThorSoundConfig.instance.FS_OUTRO);
    }

    private switchMusic() {
        SlotGame.sound.playAmbience(ThorSoundConfig.instance.MAIN_GAME_AMBIANCE);
    }

}